module.exports = __webpack_public_path__ + "static/img/activity.d76a0d3f.png";